import * as React from "react";

interface Props {
    children?: React.ReactNode;
}

export const Flush = (props: Props) => <div className="-m-4">{props.children}</div>;
